import React from "react";
import "../styles/why-choose-wrap.scss";

const WhyChoose = () => {
  return (
    <div className="wcu-area-2">
      {/* Title */}
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="title-area text-start me-xl-4 ms-xl-4">
              <span className="sec-title style2">Our Values</span>
              {/* <h2 className="sec-title style2">
                The values that shape Kiubunifu
              </h2> */}
            </div>
          </div>
        </div>
      </div>

      {/* Cards */}
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            {/* 👇 use a custom class instead of Bootstrap margins */}
            <div className="wcu-card-wrap values-align">
              {/* Integrity */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-balance-scale" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Integrity</h4>
                  <p className="wcu-card-text">
                    We are honest, truthful, and consistent in our actions and words. That is, we do the right thing, keep our promises, and stand by our principles at all times.

                  </p>
                </div>
              </div>

              {/* Professionalism */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-briefcase" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Professionalism</h4>
                  <p className="wcu-card-text">
                    We are committed to upholding the highest standards of conduct and mastery
                    in everything we do.
                  </p>
                </div>
              </div>

              {/* Innovation */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-lightbulb" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Innovation</h4>
                  <p className="wcu-card-text">
                    We like doing things differently, creating new ideas, being original and
                    thinking outside the box.
                  </p>
                </div>
              </div>

              {/* Excellence */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-star" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Excellence</h4>
                  <p className="wcu-card-text">
                    We strive to deliver outstanding results and exceed expectations through
                    our expertise, commitment and dedication to continuous improvement.
                  </p>
                </div>
              </div>

              {/* Collaboration */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-users" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Collaboration</h4>
                  <p className="wcu-card-text">
                    We believe in working together, leveraging the strengths of each other to
                    achieve common goals.
                  </p>
                </div>
              </div>

              {/* Respect */}
              <div className="wcu-card">
                <div className="icon value-icon">
                  <i className="fas fa-handshake" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Respect</h4>
                  <p className="wcu-card-text">
                    We value diversity and treat everyone with respect, dignity and fairness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
